{
	"placeholder": "Selecionar período",
	"filterBy": "Filtrar por:",
	"applyPeriod": "Definir período",
	"ariaLabels": {
		"selectDateRange": "Selecionar intervalo de datas",
		"dateRangeDialog": "Seleção de intervalo de datas",
		"dateRangeSelection": "Calendário de seleção de intervalo de datas",
		"clearSelection": "Limpar seleção de datas"
	}
}
